import { BUNDLE_LIST } from '@/pages/home/data';

export default function Bundles() {
  return (
    <section id="bundle" className="mx-auto w-full max-w-7xl scroll-mt-24 px-4 py-16 md:px-6 md:py-24">
      {/* header */}
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2 text-xs font-semibold tracking-[0.24em] text-primary-600">
            <span className="inline-block h-px w-8 bg-primary-500" />
            03 · 打包下载
          </div>
          <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
            黑料合集 · 一键打包
          </h2>
          <p className="mt-2 max-w-lg text-sm text-foreground-600">
            按事件分卷整理，标注好时间轴与来源，省去自己翻，打包即走。
          </p>
        </div>
        <a
          href="#download"
          className="inline-flex h-11 w-fit items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-download-cloud-2-line text-lg" />
          全部打包合集
        </a>
      </div>

      {/* cards */}
      <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {BUNDLE_LIST.map((b) => (
          <article
            key={b.title}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-100/40 transition-colors hover:border-primary-300"
          >
            {/* cover */}
            <div className="relative aspect-[8/5] w-full overflow-hidden">
              <img
                src={b.cover}
                alt={`抖阴黑料合集打包·${b.title}`}
                title={`抖阴黑料合集打包 · ${b.title}`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-500 px-2.5 py-1 text-[11px] font-bold text-foreground-950">
                <i className="ri-fire-fill" />
                {b.tag}
              </span>
            </div>

            {/* body */}
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-700">
                {b.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{b.desc}</p>

              <div className="mt-4 flex items-center gap-4 text-xs text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-hard-drive-2-line text-primary-500" />
                  {b.size}
                </span>
                <span className="inline-flex items-center gap-1">
                  <i className="ri-file-list-3-line text-primary-500" />
                  {b.count}
                </span>
              </div>

              <a
                href="#download"
                className="mt-4 inline-flex h-10 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-download-2-line" />
                领取该合集
              </a>
            </div>
          </article>
        ))}
      </div>

      {/* download entry band */}
      <div
        id="download"
        className="mt-10 flex flex-col items-start gap-5 rounded-lg border border-background-200/80 bg-background-100/60 p-6 sm:flex-row sm:items-center sm:justify-between md:p-7"
      >
        <div className="flex items-start gap-4">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-lock-password-line text-xl" />
          </span>
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">打包总入口 · 密码领取</h3>
            <p className="mt-1 max-w-xl text-sm text-foreground-600">
              全部合集已分卷加密，输入暗号「抖阴黑料」即可解锁本期最新打包，限时通道。
            </p>
          </div>
        </div>
        <a
          href="#download"
          className="inline-flex h-11 shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-foreground-950 px-5 text-sm font-semibold text-background-50 transition-colors hover:bg-foreground-800"
        >
          <i className="ri-archive-2-line text-lg" />
          进入打包站
        </a>
      </div>
    </section>
  );
}